const topCntnt = (() => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {

    let secCntnt = document.querySelectorAll('.js-sec-cntnt');
    let cntntBg = document.querySelectorAll('.js-sec-cntnt .js-cntnt-bg');
    let bgCover = document.querySelectorAll('.js-sec-cntnt .js-bg-cover');
    let linkCntnt = document.querySelectorAll('.js-sec-cntnt .js-link-cntnt');
    let copyBox = document.querySelectorAll('.js-sec-cntnt .copy-box');
    let sW = window.innerWidth;



    for (let i = 0; i < secCntnt.length; i++) {

      ScrollTrigger.create({
        trigger: secCntnt[i],
        start: "top 65%",
        onEnter: () => {
          copyBox[i].classList.add('act')
        },
        onLeaveBack: () => {
          copyBox[i].classList.remove('act')
        },
        // markers: true,
      });


      if (sW > 750) {

        ScrollTrigger.create({
          trigger: secCntnt[i],
          start: "top top",
          pin: true,
          // pinSpacing: false,
          // toggleClass: { targets: bgCover, className: "act" },
          onEnter: () => {
            cntntBg[i].classList.add('act')
            linkCntnt[i].classList.add('on')
            setTimeout(() => linkCntnt[i].classList.add('act'), 500);
          },
          onLeaveBack: () => {
            cntntBg[i].classList.remove('act')
            linkCntnt[i].classList.remove('on')
            linkCntnt[i].classList.remove('act')
          },
          // endTrigger: "#jsConcept",
          // end: "bottom bottom",
          // markers: true,
        });

      } else {

        ScrollTrigger.create({
          trigger: secCntnt[i],
          start: "top 50",
          pin: true,
          // pinSpacing: false,
          // toggleClass: { targets: bgCover, className: "act" },
          onEnter: () => {
            cntntBg[i].classList.add('act')
            linkCntnt[i].classList.add('on')
            setTimeout(() => linkCntnt[i].classList.add('act'), 500);
          },
          onLeaveBack: () => {
            cntntBg[i].classList.remove('act')
            linkCntnt[i].classList.remove('on')
            linkCntnt[i].classList.remove('act')
          },
          // endTrigger: "#jsConcept",
          // end: "bottom bottom",
          // markers: true,
        });

      }

    }
    
  }

})();
export default topCntnt;